import { ContractReportKeyEnum, DeviceReportKeyEnum, RentalReportKeyEnum } from '@core/enum/report';

export const REPORT_EXPORT_STORAGE_KEY = {
	// Device tab
	[DeviceReportKeyEnum.OPERATING_DEVICE_COUNT]: 'EXPORT_DEVICE_OPERATING_COUNT',
	[DeviceReportKeyEnum.DEVICE_SUMMARY_BY_PERIOD]: 'EXPORT_DEVICE_SUMMARY_PERIOD',
	[DeviceReportKeyEnum.DEVICE_DETAIL_BY_LOCATION]: 'EXPORT_DEVICE_DETAIL_LOCATION',
	[DeviceReportKeyEnum.OPERATING_DEVICE_STATUS]: 'EXPORT_DEVICE_OPERATING_STATUS',

	// Rental fee tab
	[RentalReportKeyEnum.TOTAL_RENTAL_BY_MONTH]: 'EXPORT_RENTAL_TOTAL_BY_MONTH',
	[RentalReportKeyEnum.TOTAL_RENTAL_BY_MONTH_AND_CHANNEL]: 'EXPORT_RENTAL_TOTAL_BY_MONTH_CHANNEL',
	[RentalReportKeyEnum.RENTAL_PAYMENT]: 'EXPORT_RENTAL_PAYMENT',
	[RentalReportKeyEnum.RENTAL_ANALYSIS]: 'EXPORT_RENTAL_ANALYSIS',

	// Contract tab
	[ContractReportKeyEnum.NEW_CONTRACT]: 'EXPORT_CONTRACT_NEW',
	[ContractReportKeyEnum.RENEWED_CONTRACT]: 'EXPORT_CONTRACT_RENEWED',
	[ContractReportKeyEnum.DISCOUNT_CONTRACT]: 'EXPORT_CONTRACT_DISCOUNT',
	[ContractReportKeyEnum.LIQUIDATED_CONTRACT]: 'EXPORT_CONTRACT_LIQUIDATED',
	[ContractReportKeyEnum.OPTIMIZED_CONTRACT]: 'EXPORT_CONTRACT_OPTIMIZED',

	// Contract summary
	CONTRACT_SUMMARY_MONTHLY: 'EXPORT_CONTRACT_SUMMARY_MONTHLY',
	CONTRACT_SUMMARY_DAILY: 'EXPORT_CONTRACT_SUMMARY_DAILY',
} as const;

export const DEVICE_EXPORT_STORAGE_KEYS = [
	REPORT_EXPORT_STORAGE_KEY[DeviceReportKeyEnum.OPERATING_DEVICE_COUNT],
	REPORT_EXPORT_STORAGE_KEY[DeviceReportKeyEnum.DEVICE_SUMMARY_BY_PERIOD],
	REPORT_EXPORT_STORAGE_KEY[DeviceReportKeyEnum.DEVICE_DETAIL_BY_LOCATION]
] as const;

export const RENTAL_EXPORT_STORAGE_KEYS = [
	REPORT_EXPORT_STORAGE_KEY[RentalReportKeyEnum.TOTAL_RENTAL_BY_MONTH],
	REPORT_EXPORT_STORAGE_KEY[RentalReportKeyEnum.TOTAL_RENTAL_BY_MONTH_AND_CHANNEL],
	REPORT_EXPORT_STORAGE_KEY[RentalReportKeyEnum.RENTAL_PAYMENT],
	REPORT_EXPORT_STORAGE_KEY[RentalReportKeyEnum.RENTAL_ANALYSIS]
] as const;

export const CONTRACT_EXPORT_STORAGE_KEYS = [
	REPORT_EXPORT_STORAGE_KEY[ContractReportKeyEnum.NEW_CONTRACT],
	REPORT_EXPORT_STORAGE_KEY[ContractReportKeyEnum.RENEWED_CONTRACT],
	REPORT_EXPORT_STORAGE_KEY[ContractReportKeyEnum.DISCOUNT_CONTRACT],
	REPORT_EXPORT_STORAGE_KEY[ContractReportKeyEnum.LIQUIDATED_CONTRACT],
	REPORT_EXPORT_STORAGE_KEY[ContractReportKeyEnum.OPTIMIZED_CONTRACT],
	REPORT_EXPORT_STORAGE_KEY.CONTRACT_SUMMARY_MONTHLY,
	REPORT_EXPORT_STORAGE_KEY.CONTRACT_SUMMARY_DAILY
] as const;

export type ReportExportStorageKey = typeof REPORT_EXPORT_STORAGE_KEY[keyof typeof REPORT_EXPORT_STORAGE_KEY];